// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PBFu_{display:flex;flex-direction:column;width:100%;max-width:600px;margin:0 auto;gap:24px}.z1M8z{display:flex;flex-direction:column;gap:8px}.H6bXd{font-size:14px;color:#1d1f3d}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PBFu_`,
	"section": `z1M8z`,
	"sectionLabel": `H6bXd`
};
export default ___CSS_LOADER_EXPORT___;
